import { Loading } from "@app/components";
import { useUser } from "@services/servicesGenericsTables";
import { useTypesUncertainty } from "@services/servicesGenericsTables/useTypeUncertainty";
import { useEffect, useRef } from "react";
import { Outlet } from "react-router-dom";

export default function LayoutEditUncertainty() {
  const fetched = useRef(false);

  const { fetchAll: fetchAlluser, loading } = useUser();

  useEffect(() => {
    if (!fetched.current) {
      fetched.current = true;
      fetchAlluser();
    }
  }, []);

  return loading ? <Loading /> : <Outlet />;
}
